import RestService from '../services/rest';

async function getAdmMenus(limit, skip, search, order = '', field = '', level) {
  return RestService.getAuthenticated(
    `panel/admMenu?limit=${limit}&skip=${skip}&search=${search}&order=${order}&field=${field}&level=${level || ''}`,
  );
}

async function getAdmMenu(id) {
  return RestService.getAuthenticated(`panel/admMenu/${id}`);
}

async function getAdmMenuTree(userId, profileId) {
  return RestService.getAuthenticated(`panel/admMenu/tree/getUserTree?userId=${userId}&profileId=${profileId}`);
}

async function getAdmMenuRoutes(userId, profileId) {
  return RestService.getAuthenticated(`panel/admMenu/routes/getUserRoutes?userId=${userId}&profileId=${profileId}`);
}

async function createAdmMenu(banner) {
  return RestService.postAuthenticated('panel/admMenu/create', banner);
}

async function updateAdmMenu(banner) {
  return RestService.putAuthenticated('panel/admMenu/update', banner);
}

async function deleteAdmMenu(id) {
  return RestService.postAuthenticated('panel/admMenu/delete', { id });
}

async function uploadAdmMenu(file, name, id) {
  const fd = new FormData();
  fd.append('file', file);
  return RestService.postAuthenticated(`panel/admMenu/import?&name=${name}&id=${id}`,
    fd, {
      'Content-Type': 'multipart/form-data',
    });
}

async function getCsvAdmMenusReport() {
  const response = await RestService.getAuthenticated('panel/admMenu/report/csv', {
    responseType: 'blob',
  });
  const url = window.URL.createObjectURL(new Blob(['\ufeff', response]));
  const link = document.createElement('a');
  link.href = url;
  const filePath = 'admMenu-export.csv';
  link.setAttribute('download', filePath);
  document.body.appendChild(link);
  link.click();
}

async function getCsvAdmMenuModel() {
  const response = await RestService.getAuthenticated('panel/admMenu/csv/model', {
    responseType: 'blob',
  });
  const url = window.URL.createObjectURL(new Blob(['\ufeff', response]));
  const link = document.createElement('a');
  link.href = url;
  const filePath = 'Modelo_Importação_AdmMenus CSV.csv';
  link.setAttribute('download', filePath);
  document.body.appendChild(link);
  link.click();
}

async function uploadCsvAdmMenus(file) {
  const fd = new FormData();
  fd.append('file', file);

  return RestService.postAuthenticated('panel/admMenu/import/csv', fd, {
    'Content-Type': 'multipart/form-data',
  });
}

async function saveMenuState(state) {
  return RestService.postAuthenticated('panel/admMenu/saveMenuState', state);
}
async function getMenuState() {
  return RestService.getAuthenticated(
    `panel/admMenu/getMenuState`,
  );
}

export default {
  getAdmMenus,
  getAdmMenu,
  getAdmMenuTree,
  getAdmMenuRoutes,
  createAdmMenu,
  updateAdmMenu,
  uploadAdmMenu,
  deleteAdmMenu,
  getCsvAdmMenusReport,
  getCsvAdmMenuModel,
  uploadCsvAdmMenus,
  saveMenuState,
  getMenuState
};
